import React from "react";
import { Box } from "@material-ui/core";
import { useDeviceTypes } from "halifax";
import { Skeleton } from "@material-ui/lab";

export const PreviousFlightBannerLoading = () => {
  const { matchesMobile } = useDeviceTypes();

  return (
    <>
      <Box mb={matchesMobile ? "8px" : "16px"}>
        <Skeleton variant="text" height={matchesMobile ? 18 : 25} />
      </Box>
      <Box display="flex" justifyContent="space-between">
        <Box width="45%">
          <Skeleton variant="text" height={25} />
          <Skeleton variant="text" height={20} />
        </Box>
        <Box width="45%">
          <Skeleton variant="text" height={25} />
          <Skeleton variant="text" height={20} />
        </Box>
      </Box>
    </>
  );
};
